<template>
  <div class="storage-list__result-msg mt-4 mb-2">
    <div v-if="isRenderStorageListNoResultsInfo">
      <span class="secondary--text font-weight-bold">{{
        renderStorageListNoResults
      }}</span>
    </div>
    <div
      v-if="isRenderStorageListSearchingInfo"
      class="secondary--text font-weight-bold"
    >
      {{ $t("storage.searching")
      }}{{
        selectedFolderName
          ? ` ${selectedFolderName}`
          : ` ${$t("storage.files")}`
      }}.
      {{ isRenderNoResultsInfo ? `${$t("common.no_results")}.` : "" }}
      <button
        v-if="selectedFolderName"
        @click="handleSearchAllFilesButton"
        type="button"
        class="primary--text outline-none search-all-files-button"
      >
        {{ $t("storage.search_all_files") }}
      </button>
    </div>
  </div>
</template>

<script>
import { ModuleTypes } from "@/store/ModuleTypes";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { i18n } from "@/plugins/i18n";

export default {
  name: "StorageListResultsInfo",
  props: {
    isShowSearchingInfo: {
      type: Boolean,
      default: false
    },
    handleSearchingInfoShow: {
      type: Function,
      required: true
    },
    handleFileNameChange: {
      type: Function,
      required: true
    },
    handleSelectedTagsChange: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters(ModuleTypes.STORAGE, [
      "storageSearchInputValue",
      "storageContent"
    ]),

    isRenderStorageListNoResultsInfo() {
      return (
        (this.$route.params?.playerId
          ? this.storageSearchInputValue?.length === 0
          : true) &&
        this.storageContent?.storageItems &&
        this.storageContent?.storageItems?.length === 0
      );
    },

    renderStorageListNoResults() {
      if (!this.isShowSearchingInfo) {
        if (this.$route.params?.playerId) {
          return i18n.tc("storage.no_results_player");
        } else {
          return i18n.tc("storage.no_results_coach");
        }
      }
      return "";
    },

    isRenderStorageListSearchingInfo() {
      return (
        (!this.$route.params?.playerId && this.isShowSearchingInfo) ||
        (this.$route.params?.playerId &&
          this.storageSearchInputValue.length >= 3)
      );
    },

    selectedFolderName() {
      const breadcrumbs = this.storageContent?.breadcrumbs;
      return breadcrumbs?.length
        ? breadcrumbs[breadcrumbs?.length - 1]?.name
        : "";
    },

    isRenderNoResultsInfo() {
      return (
        Array.isArray(this.storageContent?.storageItems) &&
        !this.storageContent?.storageItems?.length
      );
    }
  },
  methods: {
    ...mapMutations(ModuleTypes.STORAGE, [
      "setStorageBreadcrumbs",
      "setStorageSearchInputValue",
      "setStorageSearchInputFocused"
    ]),

    ...mapActions(ModuleTypes.STORAGE, ["fetchStorageContent"]),

    handleSearchAllFilesButton() {
      const lastBreadcrumb = this.storageContent?.breadcrumbs?.[
        this.storageContent?.breadcrumbs?.length - 1
      ];
      if (!this.$route.params?.playerId) {
        this.handleFileNameChange("");
        this.handleSelectedTagsChange([]);
        this.fetchStorageContent({
          organizationId:
            this.$route.params?.organizationId || this.$route.params?.orgId,
          parentId: lastBreadcrumb?.id,
          playerId: null,
          sharedWithMe: lastBreadcrumb?.sharedWithMe
        });
      }
      this.handleSearchingInfoShow(false);
      this.setStorageBreadcrumbs([]);
      this.setStorageSearchInputValue("");
      this.setStorageSearchInputFocused(false);
    }
  }
};
</script>

<style scoped>
.storage-list__result-msg {
  min-height: 24px;
  font-size: 13px;
}

.search-all-files-button {
  margin-left: 2px;
}
@media (max-width: 676px) {
  .storage-list__result-msg {
    margin-top: 7vh !important;
  }
}
</style>
